import { Group, Button, Box } from '@mantine/core';
import { ArrowLeft } from 'react-feather';

export interface PageFooterProps {
  isValid: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export function PageFooter({ isValid, isSubmitting, onCancel, onSubmit }: PageFooterProps) {
  return (
    <Box
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 100,
        background: 'white',
        borderTop: '1px solid var(--mantine-color-gray-2)',
      }}
      py="md"
      px="lg"
    >
      <Group justify="space-between">
        <Button variant="default" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          color="dark"
          rightSection={<ArrowLeft size={16} style={{ transform: 'rotate(180deg)' }} />}
          disabled={!isValid}
          loading={isSubmitting}
          onClick={onSubmit}
        >
          Submit Response
        </Button>
      </Group>
    </Box>
  );
}
